(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("BTWebComponents", [], factory);
	else if(typeof exports === 'object')
		exports["BTWebComponents"] = factory();
	else
		root["BTWebComponents"] = factory();
})(self, () => {
return 